import ScrollToTop from "../../components/scrollToTop/scrollToTop";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import "../contract-national/cont_nat.css";

function TermsLogisticsContract() {
  const [t] = useTranslation("termsLogisticsContract");

  sessionStorage.setItem(
    "routeEs",
    "/terminos-y-condiciones-contrato-operacion-logistica"
  );
  sessionStorage.setItem(
    "routeEn",
    "/terms-and-conditions-logistics-operation-contract"
  );

  return (
    <>
      <Helmet>
        <title>Términos y Condiciones – Contrato de Operación Logística | AM Cargo</title>
        <meta
          name="description"
          content="Términos y Condiciones al Contrato de Operación Logística Persona Moral de AM Cargo."
        />
      </Helmet>
      <ScrollToTop />
   

      {/* Banner gris superior */}
      <div className="container-fluid backg-gray">
        <div className="row">
          <div className="col">
            {t("header.subtitulo")}
          </div>
        </div>
      </div>

      {/* Contenido principal */}
      <section className="container national-contract-container contractsContainer">
        <div className="row">
          <div className="col">
            <h1>{t("header.titulo")}</h1>
            <p><small>{t("updated")}</small></p>

            {/* PRIMERO */}
            <p><strong>{t("primero.titulo")}</strong></p>
            <p>{t("primero.intro")}</p>
            <p>1. {t("primero.1")}</p>
            <p>2. {t("primero.2")}</p>
            <p>3. {t("primero.3")}</p>
            <p>4. {t("primero.4")}</p>
            <p>5. {t("primero.5")}</p>
            <p>6. {t("primero.6")}</p>
            <p>7. {t("primero.7")}</p>
            <p>8. {t("primero.8")}</p>
            <p>9. {t("primero.9")}</p>
            <p>10. {t("primero.10")}</p>

            {/* SEGUNDO */}
            <p><strong>{t("segundo.titulo")}</strong></p>
            <p>{t("segundo.intro")}</p>
            <p>1. {t("segundo.1")}</p>
            <p>2. {t("segundo.2")}</p>
            <p>3. {t("segundo.3")}</p>
            <p>4. {t("segundo.4")}</p>
            <p>5. {t("segundo.5")}</p>
            <p>6. {t("segundo.6")}</p>
            <p>7. {t("segundo.7")}</p>

            {/* TERCERO */}
            <p><strong>{t("tercero.titulo")}</strong></p>
            <p>{t("tercero.p1")}</p>
            <p>{t("tercero.p2")}</p>
            <p>{t("tercero.p3")}</p>

            {/* CUARTO */}
            <p><strong>{t("cuarto.titulo")}</strong></p>
            <p>{t("cuarto.p1")}</p>
            <p>{t("cuarto.p2")}</p>
            <p>{t("cuarto.p3")}</p>

            {/* QUINTO */}
            <p><strong>{t("quinto.titulo")}</strong></p>
            <p>{t("quinto.intro")}</p>
            <p>a) {t("quinto.a")}</p>
            <p>b) {t("quinto.b")}</p>
            <p>c) {t("quinto.c")}</p>
            <p>d) {t("quinto.d")}</p>
            <p>e) {t("quinto.e")}</p>
            <p>f) {t("quinto.f")}</p>
            <p>{t("quinto.cierre")}</p>

            {/* SEXTO */}
            <p><strong>{t("sexto.titulo")}</strong></p>
            <p>{t("sexto.p1")}</p>
            <p>{t("sexto.p2")}</p>

            {/* SÉPTIMO */}
            <p><strong>{t("septimo.titulo")}</strong></p>
            <p>{t("septimo.intro")}</p>
            <p><strong>{t("septimo.def1_titulo")}</strong> {t("septimo.def1")}</p>
            <p><strong>{t("septimo.def2_titulo")}</strong> {t("septimo.def2")}</p>
            <p>{t("septimo.p1")}</p>
            <p>{t("septimo.p2")}</p>
            <p>{t("septimo.p3")}</p>
            <p>{t("septimo.p4")}</p>

            {/* OCTAVO */}
            <p><strong>{t("octavo.titulo")}</strong></p>
            <p>{t("octavo.p1")}</p>

            {/* NOVENO */}
            <p><strong>{t("noveno.titulo")}</strong></p>
            <p>{t("noveno.p1")}</p>
            <p>{t("noveno.p2")}</p>
            <p>{t("noveno.p3")}</p>

            {/* DÉCIMO */}
            <p><strong>{t("decimo.titulo")}</strong></p>
            <p>{t("decimo.p1")}</p>
            <p>{t("decimo.p2")}</p>
            <p>{t("decimo.p3")}</p>
            <p>{t("decimo.p4")}</p>
            <p>{t("decimo.p5")}</p>
            <p>{t("decimo.p6")}</p>
            <p>{t("decimo.p7")}</p>
            <p>{t("decimo.p8")}</p>
            <p>{t("decimo.p9")}</p>
            <p>{t("decimo.p10")}</p>
            <p>{t("decimo.p11")}</p>
            <p>{t("decimo.p12")}</p>
            <p>{t("decimo.p13")}</p>
            <p>{t("decimo.p14")}</p>

            {/* DÉCIMO PRIMERO */}
            <p><strong>{t("decimoprimero.titulo")}</strong></p>
            <p>{t("decimoprimero.p1")}</p>
            <p>{t("decimoprimero.p2")}</p>
            <p>{t("decimoprimero.p3")}</p>

            {/* DÉCIMO SEGUNDO */}
            <p><strong>{t("decimosegundo.titulo")}</strong></p>
            <p>{t("decimosegundo.p1")}</p>

            {/* DÉCIMO TERCERO */}
            <p><strong>{t("decimotercero.titulo")}</strong></p>
            <p>{t("decimotercero.p1")}</p>
            <p>{t("decimotercero.p2")}</p>

            {/* DÉCIMO CUARTO */}
            <p><strong>{t("decimocuarto.titulo")}</strong></p>
            <p>{t("decimocuarto.p1")}</p>

            {/* DÉCIMO QUINTO */}
            <p><strong>{t("decimoquinto.titulo")}</strong></p>
            <p>{t("decimoquinto.p1")}</p>
            <p>{t("decimoquinto.p2")}</p>
            <p>{t("decimoquinto.p3")}</p>

            {/* DÉCIMO SEXTO */}
            <p><strong>{t("decimosexto.titulo")}</strong></p>
            <p>{t("decimosexto.p1")}</p>
            <p>{t("decimosexto.p2")}</p>
            <p>{t("decimosexto.p3")}</p>

            {/* DÉCIMO SÉPTIMO */}
            <p><strong>{t("decimoseptimo.titulo")}</strong></p>
            <p>{t("decimoseptimo.p1")}</p>
            <p>{t("decimoseptimo.p2")}</p>
            <p>{t("decimoseptimo.p3")}</p>
            <p>{t("decimoseptimo.p4")}</p>
            <p>{t("decimoseptimo.p5")}</p>
            <p>{t("decimoseptimo.p6")}</p>
            <p>{t("decimoseptimo.p7")}</p>
            <p>{t("decimoseptimo.p8")}</p>

            {/* DÉCIMO OCTAVA */}
            <p><strong>{t("decimooctava.titulo")}</strong></p>
            <p>{t("decimooctava.p1")}</p>

            {/* DÉCIMO NOVENA */}
            <p><strong>{t("decimonovena.titulo")}</strong></p>
            <p>{t("decimonovena.p1")}</p>

            {/* VIGÉSIMO */}
            <p><strong>{t("vigesimo.titulo")}</strong></p>
            <p>{t("vigesimo.p1")}</p>

            {/* VIGÉSIMO PRIMERA */}
            <p><strong>{t("vigesimoprimera.titulo")}</strong></p>
            <p>{t("vigesimoprimera.p1")}</p>
          </div>
        </div>
      </section>

    </>
  );
}

export default TermsLogisticsContract;
